import {SolrEntity} from "./solr-entity";

export class NotificationDTO extends SolrEntity{
    isShowShare: boolean;
    type: string;
    dateDifference: string;
    fileAttachmentPath: string;

    constructor(attributes?: object) {
        super(attributes);
        attributes = attributes ? attributes : {};
        this.type = attributes['additional_notification_data_property_1_s'] || '';
        this.isShowShare = attributes['additional_notification_data_property_2_s'] == 1;
        this.fileAttachmentPath = attributes['additional_notification_data_property_3_s']? attributes['additional_notification_data_property_3_s'] : null;
        this.dateDifference = this.getDateDifference(this.date)
    }

    getDateDifference(date) {
        const today = new Date();
        const notificationDate = new Date(date);
        switch (true) {
            case notificationDate.getDate() == today.getDate() && this.isSameMonth(today, notificationDate):
                return `${notificationDate.getHours()}:${notificationDate.getMinutes()}`;
            case  notificationDate.getDate() == (today.getDate() - 1):
                return 'Yesterday';
            default:
                return notificationDate.toLocaleDateString()
        }
    }

    isSameMonth(date1: Date, date2: Date): boolean {
        return  date1.getMonth() == date2.getMonth() &&
            date1.getFullYear() == date2.getFullYear();
    }
}
